import { useGetAuthConfig } from 'features/auth/api/hooks/useGetAuthConfig';

/**
 * Hook return method to check if the domain is a valid SSO domain
 * When SSO is disabled, the domain is always valid
 * @returns {boolean} - true if the domain is valid
 */
const useSsoDomainCheck = () => {
  const { data: { allowedDomains = [] } = { allowedDomains: [] } } =
    useGetAuthConfig();

  return (email: string) => {
    if (!allowedDomains.length) {
      return true;
    }

    const domain = email.split('@')[1];
    return allowedDomains.includes(domain);
  };
};

export default useSsoDomainCheck;
